import {
  defaultCellRenderer,
  defaultGroupRenderer as groupRenderer,
  generateMultiFilterConfigFromModel, linkifyText
} from "../../utils/utils.jsx";
import { WIDGET_KEYS } from "../WidgetKeys.jsx";
import { customGroupByOrder } from "../../utils/otherUtils.jsx";
import { Task } from "../../../bryntum-lib/models/Task";
import { TASK_BUDGET_FIELDS } from "../OtherKeys.jsx";

export const SCHEDULER_VIEW_PLANS_COLUMNS = [
  {
    id: "schedule-task-name",
    field: "name",
    text: "Task",
    type: "unplannedTask",
    region: "locked",
    width: 300,
    editor: false,
    cellCls: "b-sch-horizontal",
    regionsToIgnore: ["locked"],
    headerMenuItems: {
      addNewEntity: {
        _menuId: "task",
        icon: "fa-plus",
        text: "New Task",
        weight: 10,
      },
      taskFinder: {
        _menuId: "taskFinder",
        icon: "fa fa-search",
        text: "Find",
        weight: 430
      },
      textWrapping: {
        text: "Enable Text Wrapping",
        checked: false,
        weight: 440,
        regionsToIgnore: ["locked"]
      }
    }
  },
  { id: "schedule-contacts", type: WIDGET_KEYS.contactColumn },
  { id: "schedule-reminder-bell", type: WIDGET_KEYS.alertBellColumn, isAlertBell: true },
  {
    id: "schedule-budget-column",
    type: WIDGET_KEYS.budgetAccountColumn,
  },
  { id: "schedule-task-checklist", type: WIDGET_KEYS.checklistColumn },
  { id: "schedule-task-notes", type: WIDGET_KEYS.notesColumn },
  { id: "schedule-task-media", type: WIDGET_KEYS.mediaColumn },
  { id: "schedule-task-documents", type: WIDGET_KEYS.documentsColumn },
  { id: "schedule-task-istaskscheduled", type: WIDGET_KEYS.scheduledColumn },
  {
    id: "schedule-task-budget-id",
    type: WIDGET_KEYS.columnTaskBudgetTitle,
    field: TASK_BUDGET_FIELDS.title,
  },
  {
    id: "schedule-task-team",
    text: "Team",
    field: "teamValue",
    type: WIDGET_KEYS.teamField,
    flex: 1,
    editor: false,
    swivuListTitle: "Task Team",
    headerMenuItems: {
      columnItem: customGroupByOrder("teamId", "teamStore")
    }
  },
  { id: "schedule-task-address",
    type: WIDGET_KEYS.swivuAddressColumn,
    text: "Task Location",
  },
  {
    id: "schedule-task-status",
    text: "Status",
    editor: false,
    type: WIDGET_KEYS.columnTaskStatus,
    field: "statusValue",
    flex: 1,
    headerMenuItems: {
      columnItem: customGroupByOrder("statusId", "tagStore")
    }
  },
  {
    id: "schedule-task-description",
    text: "Description",
    field: "description",
    type: WIDGET_KEYS.swivuStateColumn,
    flex: 1,
    cellCls: "!overflow-hidden",
    renderer: ({ record }) => linkifyText(defaultCellRenderer({ value: record.description })),
    groupRenderer,
    regionsToIgnore: ["locked"],
    headerMenuItems: {
      textWrapping: {
        text: "Enable Text Wrapping",
        checked: false,
        regionsToIgnore: ["locked"]
      }
    }
  },
  {
    id: "schedule-task-client",
    swivuListTitle: "Client",
    type: WIDGET_KEYS.columnTaskClient,
    field: "clientName",
  },
  { id: "schedule-task-aging", text: "Age", field: "aging", flex: 1, type: "agingColumn", editor: false},
  {
    id: "schedule-task-phase",
    text: "Phase",
    editor: false,
    type: WIDGET_KEYS.columnTaskPhase,
    field: "phaseValue",
    flex: 1,
    headerMenuItems: {
      columnItem: customGroupByOrder("phaseId", "tagStore")
    }
  },
  {
    id: "schedule-task-category",
    text: "Category",
    editor: false,
    type: WIDGET_KEYS.columnTaskCategory,
    field: "categoryValue",
    flex: 1,
    headerMenuItems: {
      columnItem: customGroupByOrder("categoryId", "tagStore")
    }
  },
  {
    id: "schedule-task-tag",
    text: "Tags",
    editor: false,
    type: WIDGET_KEYS.columnTaskTag,
    field: "tagsValue",
    flex: 1,
  },
];

export const SCHEDULE_VIEW_FILTER_FIELD_CONFIG = {
  ...generateMultiFilterConfigFromModel(Task),
  // This is not a model field, but rather an accessor. Therefore code cannot infer the type and we have to set it manually
  clientName: { type: 'string' },
  tagsValue: { type: '_swivu_settings' },
  categoryValue: { type: '_swivu_settings' },
  statusValue: { type: '_swivu_settings' },
  teamValue: { type: '_swivu_settings' } ,
  phaseValue: { type: '_swivu_settings' } ,
  [TASK_BUDGET_FIELDS.title]: { type: 'string' },
  locationValue: { type: 'string' }
};
